import { useParams } from 'react-router-dom'

export const useLogisticIdParam = (): string => {
  const params: any = useParams()
  return params?._id ?? undefined
}
